// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum EstimateTypes {
  BaseEstimate = 1,
  AlternateEstimate = 2,
  BudgetEstimate = 3,
  ChangeOrderEstimate = 4,
}
